<template>
    <a href="#" @click.prevent="onClick">
        <slot/>
        <form ref="form" :method="formMethod" :action="link" v-show="false">
            <input type="hidden" name="_method" :value="linkMethod">
            <input type="hidden" name="_token" :value="token">
            <input v-for="(item, index) in params" :key="index" type="hidden" :name="index" :value="item">
        </form>
    </a>
</template>

<script>
    export default {
        props: {
            link: {
                default: '',
                required: true
            },
            linkMethod: {
                type: String,
                default: 'get'
            },
            confirmMessage: {
                type: String,
                default: ''
            },
            params: {
                type: Object,
                default: null
            }
        },
        methods: {
            onClick(e) {
                if (this.confirmMessage.length > 0) {
                    if (!confirm(this.confirmMessage)) {
                        e.preventDefault();
                        return;
                    }
                }

                this.$refs.form.submit();
            }
        },
        computed: {
            formMethod() {
                return this.linkMethod === 'GET' ? 'GET' : 'POST';
            },
            token() {
                return document.head.querySelector('meta[name="csrf-token"]').content;
            }
        }
    }
</script>
